export const CATEGORY_ACTIONS = {
  FETCH_REQUEST: "CATEGORY_FETCH_REQUEST",
  FETCH_SUCCESS: "CATEGORY_FETCH_SUCCESS",
  FETCH_FAILURE: "CATEGORY_FETCH_FAILURE",

  FETCH_BY_ID_REQUEST: "CATEGORY_FETCH_BY_ID_REQUEST",
  FETCH_BY_ID_SUCCESS: "CATEGORY_FETCH_BY_ID_SUCCESS",
  FETCH_BY_ID_FAILURE: "CATEGORY_FETCH_BY_ID_FAILURE",

  ADD_REQUEST: "CATEGORY_ADD_REQUEST",
  ADD_SUCCESS: "CATEGORY_ADD_SUCCESS",
  ADD_FAILURE: "CATEGORY_ADD_FAILURE",

  UPDATE_REQUEST: "CATEGORY_UPDATE_REQUEST",
  UPDATE_SUCCESS: "CATEGORY_UPDATE_SUCCESS",
  UPDATE_FAILURE: "CATEGORY_UPDATE_FAILURE",

  DELETE_REQUEST: "CATEGORY_DELETE_REQUEST",
  DELETE_SUCCESS: "CATEGORY_DELETE_SUCCESS",
  DELETE_FAILURE: "CATEGORY_DELETE_FAILURE",
};


export const COUNTRY_ACTIONS = {
  FETCH_REQUEST: "COUNTRY_FETCH_REQUEST",
  FETCH_SUCCESS: "COUNTRY_FETCH_SUCCESS",
  FETCH_FAILURE: "COUNTRY_FETCH_FAILURE",

  FETCH_BY_ID_REQUEST: "COUNTRY_FETCH_BY_ID_REQUEST",
  FETCH_BY_ID_SUCCESS: "COUNTRY_FETCH_BY_ID_SUCCESS",
  FETCH_BY_ID_FAILURE: "COUNTRY_FETCH_BY_ID_FAILURE",

  ADD_REQUEST: "COUNTRY_ADD_REQUEST",
  ADD_SUCCESS: "COUNTRY_ADD_SUCCESS",
  ADD_FAILURE: "COUNTRY_ADD_FAILURE",

  UPDATE_REQUEST: "COUNTRY_UPDATE_REQUEST",
  UPDATE_SUCCESS: "COUNTRY_UPDATE_SUCCESS",
  UPDATE_FAILURE: "COUNTRY_UPDATE_FAILURE",

  DELETE_REQUEST: "COUNTRY_DELETE_REQUEST",
  DELETE_SUCCESS: "COUNTRY_DELETE_SUCCESS",
  DELETE_FAILURE: "COUNTRY_DELETE_FAILURE",
};


export const CARD_ACTIONS = {
  FETCH_REQUEST: "CARD_FETCH_REQUEST",
  FETCH_SUCCESS: "CARD_FETCH_SUCCESS",
  FETCH_FAILURE: "CARD_FETCH_FAILURE",

  FETCH_BY_ID_REQUEST: "CARD_FETCH_BY_ID_REQUEST",
  FETCH_BY_ID_SUCCESS: "CARD_FETCH_BY_ID_SUCCESS",
  FETCH_BY_ID_FAILURE: "CARD_FETCH_BY_ID_FAILURE",

  ADD_REQUEST: "CARD_ADD_REQUEST",
  ADD_SUCCESS: "CARD_ADD_SUCCESS",
  ADD_FAILURE: "CARD_ADD_FAILURE",

  UPDATE_REQUEST: "CARD_UPDATE_REQUEST",
  UPDATE_SUCCESS: "CARD_UPDATE_SUCCESS",
  UPDATE_FAILURE: "CARD_UPDATE_FAILURE",

  DELETE_REQUEST: "CARD_DELETE_REQUEST",
  DELETE_SUCCESS: "CARD_DELETE_SUCCESS",
  DELETE_FAILURE: "CARD_DELETE_FAILURE",
};


export const OFFERING_ACTIONS = {
  FETCH_REQUEST: "OFFERING_FETCH_REQUEST",
  FETCH_SUCCESS: "OFFERING_FETCH_SUCCESS",
  FETCH_FAILURE: "OFFERING_FETCH_FAILURE",

  FETCH_BY_ID_REQUEST: "OFFERING_FETCH_BY_ID_REQUEST",
  FETCH_BY_ID_SUCCESS: "OFFERING_FETCH_BY_ID_SUCCESS",
  FETCH_BY_ID_FAILURE: "OFFERING_FETCH_BY_ID_FAILURE",

  ADD_REQUEST: "OFFERING_ADD_REQUEST",
  ADD_SUCCESS: "OFFERING_ADD_SUCCESS",
  ADD_FAILURE: "OFFERING_ADD_FAILURE",

  UPDATE_REQUEST: "OFFERING_UPDATE_REQUEST",
  UPDATE_SUCCESS: "OFFERING_UPDATE_SUCCESS",
  UPDATE_FAILURE: "OFFERING_UPDATE_FAILURE",

  DELETE_REQUEST: "OFFERING_DELETE_REQUEST",
  DELETE_SUCCESS: "OFFERING_DELETE_SUCCESS",
  DELETE_FAILURE: "OFFERING_DELETE_FAILURE",
};

export const CHATBOT_ACTIONS = {
  CHECK_BRAND_DS_REQUEST: "CHECK_BRAND_DS_REQUEST",
  CHECK_BRAND_DS_SUCCESS: "CHECK_BRAND_DS_SUCCESS",
  CHECK_BRAND_DS_FAILURE: "CHECK_BRAND_DS_FAILURE",
};


export const OFFER_ACTION_TYPES = {
  REQUEST: "FETCH_OFFER_REQUEST",
  SUCCESS: "FETCH_OFFER_SUCCESS",
  FAILURE: "FETCH_OFFER_FAILURE",
};